import { StrictMode } from "react";
import { createRoot } from "react-dom/client";
import "./index.css";
import App from "./App.jsx";
import * as pdfJs from "pdfjs-dist";
import ThemeProvider from "./providers/ThemeProvider";

pdfJs.GlobalWorkerOptions.workerSrc = "/pdfjs-dist/build/pdf.worker.mjs";

createRoot(document.getElementById("root")).render(
  <ThemeProvider>
    <StrictMode>
      <App />
    </StrictMode>
  </ThemeProvider>
);
